import { popularRouteLinks } from "../lib/routes";

/**
 * Shared site footer: popular-route links (site-wide internal linking),
 * navigation (About / Contact), the data disclaimers, and the developer
 * credit. Used by the home page and content pages.
 */
export default function SiteFooter() {
  const routes = popularRouteLinks().slice(0, 8);

  return (
    <footer className="w-full bg-slate-50 dark:bg-slate-950 mt-auto py-6">
      <div className="max-w-2xl mx-auto px-4 text-center space-y-3">
        {/* Popular routes (site-wide internal links) */}
        <nav aria-label="Popular routes" className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0.5">
          {routes.map((r) => (
            <a
              key={r.slug}
              href={`/${r.slug}`}
              className="inline-flex items-center min-h-[24px] px-2 py-1 text-[11px] font-medium text-slate-600 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
            >
              {r.label}
            </a>
          ))}
          <a href="/routes" className="inline-flex items-center min-h-[24px] px-2 py-1 text-[11px] font-semibold text-blue-600 dark:text-blue-400 hover:underline">
            All routes →
          </a>
        </nav>

        {/* Navigation */}
        <nav className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
          <a href="/blog" className="inline-flex items-center min-h-[24px] px-2 py-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            Blog
          </a>
          <span className="text-slate-300 dark:text-slate-700" aria-hidden="true">•</span>
          <a href="/about" className="inline-flex items-center min-h-[24px] px-2 py-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            About Us
          </a>
          <span className="text-slate-300 dark:text-slate-700" aria-hidden="true">•</span>
          <a href="/contact" className="inline-flex items-center min-h-[24px] px-2 py-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            Contact Us
          </a>
          <span className="text-slate-300 dark:text-slate-700" aria-hidden="true">•</span>
          <a href="/privacy" className="inline-flex items-center min-h-[24px] px-2 py-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            Privacy Policy
          </a>
          <span className="text-slate-300 dark:text-slate-700" aria-hidden="true">•</span>
          <a href="/terms" className="inline-flex items-center min-h-[24px] px-2 py-1 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            Terms of Service
          </a>
        </nav>

        {/* Disclaimers */}
        <div className="space-y-1.5">
          <p className="text-[10px] font-semibold text-amber-600 dark:text-amber-500/80 leading-relaxed max-w-md mx-auto">
            ⚠️ Bus timings are indicative only and may vary by a few minutes. Always allow buffer time and verify with your nearest depot.
          </p>
          <p className="text-[10px] font-medium text-slate-600 dark:text-slate-400 leading-relaxed max-w-md mx-auto">
            Not affiliated with the official Haryana Roadways transport department. All bus timetable data is shown from publicly available information and official schedules. Cross-verify with transport depots directly.
          </p>
        </div>

        {/* Developer credit */}
        <p className="text-[10px] font-medium text-slate-600 dark:text-slate-400">
          Developed by{" "}
          <a
            href="https://pariksarthi.com"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center min-h-[24px] font-semibold text-slate-700 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 hover:underline transition-colors"
          >
            Pariksarthi Edutech Pvt. Ltd.
          </a>
        </p>
      </div>
    </footer>
  );
}
